// Helper functions for API authentication

/**
 * Récupère le token d'authentification depuis les cookies
 * @returns Le token JWT ou null si non trouvé
 */
export const getAuthToken = (): string | null => {
  const match = /access_token=([^;]+)/.exec(document.cookie);
  return match ? decodeURIComponent(match[1]) : null;
};

/**
 * Crée les headers d'authentification pour les requêtes API
 * @returns Les headers avec Authorization Bearer token si disponible
 */
export const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

/**
 * Effectue un fetch avec authentification automatique
 * @param url L'URL de la requête
 * @param options Options fetch supplémentaires
 * @returns Promise de la réponse fetch
 */
export const authFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const headers = getAuthHeaders();
  
  return fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  });
};
